;(function(w){
	function LightboxContenidoTimeline(){
		this.main = document.getElementById('timeline');

		var content = $(this.main).find('.timeline-item')[0];

		var holder = $(this.main).find('.timeline-holder')[0];

		var arr_items = [];

		$(holder).find('li').each(function(){
			arr_items.push(this);
			$(this).bind('click', onClickItem);
		})

		
		var actual = 0;

		var imagen_aux = new Image();

		$(imagen_aux).bind('load', onLoadImageAux);
		
		goItem(actual);


		function onClickItem(e){
			e.preventDefault();

			goItem($(this).index());

		}

		function goItem(id){
			$(arr_items[actual]).removeClass('active');
			actual = id;
			$(arr_items[actual]).addClass('active');

			var info = $(arr_items[actual]).data('info');

			$(content).find('.photo-holder').addClass('loading');

			imagen_aux.src = FILES_PATH+'timeline/'+info.imagen;

			$(content).find('.bg').css('background-image','none');
			$(content).find('.ano').html(info.ano);
			$(content).find('.fecha').html(info.fecha);
			$(content).find('.texto').html(info.texto);

			var pos = $(arr_items[actual]).offset().left - $(holder).offset().left + $(arr_items[actual]).width()/2;

			$(holder).css('left', -pos);

		}

		function onLoadImageAux(e){
			$(content).find('.photo-holder').removeClass('loading');
			$(content).find('.bg').css('background-image','url('+imagen_aux.src+')');
		}



	}
	
	w.LightboxContenidoTimeline = LightboxContenidoTimeline;
})(window)